import { MethodDescription } from '../method-description';

export const VerifyTokenMethodDescription = new MethodDescription();

VerifyTokenMethodDescription.name = 'verifyToken';
VerifyTokenMethodDescription.fields = [];
VerifyTokenMethodDescription.usesToken = true;
